import Link from "next/link";

export default function Footer() {
    const quickLinks = [
        { label: "About", href: "/about" },
        { label: "AR VR MR", href: "/projects/ar-vr-mr" },
        { label: "App Development", href: "/projects/app-development" },
        { label: "Web Development", href: "/projects/web-development" },
        { label: "UI / UX", href: "/projects/ui-ux-design" },
        { label: "AI Consultancy", href: "/projects/ai-consultancy" },
        { label: "Contact", href: "/contact" },
    ];

    return (
        <footer className="bg-[#1c1c1c] text-white pt-32 pb-0 overflow-hidden" data-header-theme="light" data-barba-prevent="all">

            <div className="px-6 md:px-20 lg:px-40">
                <div className="container mx-auto">
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16">
                        {/* Left Column - Headline & Socials */}
                        <div className="lg:col-span-5">
                            <h4 className="text-[3rem] md:text-[4rem] font-bold leading-[1.1] tracking-tight mb-6">
                                Helping<br />
                                start-ups<br />
                                scale & grow.
                            </h4>

                            <div className="mb-10 mt-8">
                                <Link
                                    href="/contact"
                                    className="inline-flex items-center gap-2 px-6 py-2.5 border border-white/20 text-white rounded-full text-lg font-medium hover:bg-white hover:text-black transition-all duration-300 group"
                                >
                                    Get In Touch
                                    <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-5 h-5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"
                                    >
                                        <path
                                            d="M3.33331 12.6667L12.6666 3.33337M12.6666 3.33337V12.4M12.6666 3.33337H3.59998"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </Link>
                            </div>


                        </div>

                        {/* Middle Column - Quick Links */}
                        <div className="lg:col-span-4">
                            <h4 className="flex items-center gap-2 mb-6 text-[18px] font-medium">
                                <span className="w-1.5 h-1.5 rounded-full bg-white"></span>
                                Quick links
                            </h4>

                            <div className="flex flex-wrap gap-2">
                                {quickLinks.map((link, i) => (
                                    <Link
                                        key={i}
                                        href={link.href}
                                        className="px-4 py-2 border border-white/20 rounded-full text-[11px] font-medium text-gray-300 hover:bg-white hover:text-black hover:border-white transition-all duration-300 uppercase tracking-wider"
                                    >
                                        {link.label}
                                    </Link>
                                ))}
                            </div>
                        </div>

                        {/* Right Column - Contact */}
                        <div className="lg:col-span-3">
                            <h4 className="flex items-center gap-2 mb-5 text-[18px] font-medium">
                                <span className="w-1.5 h-1.5 rounded-full bg-white"></span>
                                Contact
                            </h4>

                            <div className="space-y-3 text-gray-400 text-[16px]">
                                <a
                                    href="tel:+917907157244"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="block hover:text-white transition-colors"
                                >
                                    (91) 79071 57244
                                </a>
                                <a
                                    href="https://www.google.com/maps/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="block leading-relaxed hover:text-white transition-colors"
                                    aria-label="View our location on Google Maps"
                                >
                                    Level 4, Dotspace Business Centre,<br />
                                    Total Tower, Elamakara, Edappally,<br />
                                    Cochin, Kerala - 682024
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom - Massive Text */}
            <div className="w-full flex justify-end mt-16 px-6 md:px-20 lg:px-40">
                <p className="text-[11vw] leading-[0.8] font-bold tracking-tighter text-white text-right mb-[10px] mr-0 md:mr-[-70px]">
                    hello@kitebe.in
                </p>
            </div>
        </footer>
    );
}
